// NPM imports
import React from "react";
import { connect } from "react-redux";
import { NumberInput } from "@revvsales/components";

// Components Imports
import FormField from "../PricebookItemEditor/FormField";

// Actions Imports
import PricebooksActions from "../../../actions/PricebooksActions";

// Destructuring
const { updatePricingMethodData } = PricebooksActions;

// Component
function DIYPricing(props) {
  const { customMatrixFields, currencySymbol } = props;
  // temp code to show '----' option in qty_uom drop down filed
  const customJson = customMatrixFields.map(option => {
    if (option.name === "quantity_uom") {
      option.required = false;
    }
    return option;
  });
  // Render Section
  return (
    <div className="diypricing-wrapper">
      <section>
        {customJson.map(fields => (
          <FormField {...fields} isEdit={props.isEdit} key={fields.fld} />
        ))}
        <span className="popupform-label">MINIMUM PRICE</span>
        <NumberInput
          inpCurrencySymbol={currencySymbol}
          isCurrency
          isFloat
          onChange={value =>
            props.updatePricingMethodData("diyPricing", {
              minPrice: value,
            })
          }
          placeholder="Enter Minimum Price"
          value={props.data.minPrice}
          data-test="diypricing-number-input"
        />
      </section>
      <section className="diypricing-helptext">
        <div className="diypricing-helptext-title">Help Text</div>
        <div className="diypricing-helptext-content">
          Choose DIY PRICING for products that require custom pricing, that is,
          pricing on a deal to deal basis. When you add the product in the Deal
          Table, it appears as an open line item where you can directly enter
          the price, quantity, selling term and discount.
        </div>
      </section>
    </div>
  );
}

const mapStateToProps = store => {
  const {
    pricingMethodData: { diyPricing: data } = {}, // Targed nested keys and set use a specific name for it => priceingMethodData.diyPricing = data
    props: { quantity_uom: qtyUom = [] },
  } = store.PricebookStore;
  return {
    data,
    qtyUom,
  };
};

const mapDispatchToProps = {
  updatePricingMethodData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DIYPricing);



// WEBPACK FOOTER //
// ./src/components/Pricebook/DIYPricing/DIYPricing.js